<template>
  <div class="card-selection-skeleton" :style="{ width: cardWidth }">
    <div class="card-selection-skeleton__img">
      <animated-placeholder :height="imageHeight" width="100%" />
    </div>
    <div class="card-selection-skeleton__description">
      <animated-placeholder height="10px" width="40%" />
      <animated-placeholder height="8px" width="90%" />
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import AnimatedPlaceholder from '@/libs/AnimatedPlaceholder.vue'

  const props = defineProps({
    width: { type: String, default: '100%' },
    justifyContent: { type: String, default: 'space-between' },
    imageHeight: { type: String, default: '100%' },
    borderRadius: { type: String, default: '20px' },
    imageWidth: { type: String, default: '40%' }
  })

  const cardWidth = computed(() => props.width)
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .card-selection-skeleton {
    display: flex;
    height: v-bind(height);
    flex-direction: row;
    justify-content: v-bind(justifyContent);
    align-items: 'flex-start';
    gap: 10px;
    border-radius: v-bind(borderRadius);
    border: 1px solid #ddd;
    background: var(--theme-color);
    &__img {
      border-radius: v-bind(borderRadius);
      width: v-bind(imageWidth);
      height: 100%;
    }

    &__description {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: initial;
      width: 60%;
      padding: 25px 15px 20px 15px;
      gap: 20px;
      align-self: stretch;
      overflow-x: hidden;
    }
  }
</style>
